import { defineStore, storeToRefs } from 'pinia';

const name = 'audio';

export default defineStore(name, {
  state: () => ({
    isRecord: false,
    isCloneVoice: false,
    isSpiderMedia: false,
    audioFile: null as File | null,
    audioUrl: '' as string | undefined,
    audioFid: '' as string,
    activeAudioRegion: {} as ActiveAudioRegion,
    activeSourceUrl: '' as string,
  }),
  actions: {},
});
